import React, { useState } from 'react';
import BrandLogo from '../BrandLogo';
import SupportDialog from '../SupportDialog';
import LegalLinks from '../legal/LegalLinks';

/**
 * Alt bilgi. Hukuki metinler (aydınlatma, çerez) giriş yapmadan da
 * erişilebilir olmak zorunda — KVKK m.10 — o yüzden LegalLinks burada şart.
 *
 * Yardım: giriş ekranındaki aynı SupportDialog (destek kanalları
 * config/support.ts'te tek yerde).
 */
const LandingFooter: React.FC = () => {
  const [helpOpen, setHelpOpen] = useState(false);
  return (
    <footer className="lp-footer">
      <div className="lp-wrap lp-footer__inner">
        <div className="lp-footer__brand">
          <BrandLogo variant="mark" className="lp-footer__logo" />
          <p>© {new Date().getFullYear()} eis ekosis LMS</p>
        </div>
        <div className="lp-footer__links">
          <button
            type="button"
            className="lp-footer__help"
            onClick={() => setHelpOpen(true)}
            aria-haspopup="dialog"
            aria-expanded={helpOpen}
          >
            Yardıma mı ihtiyacın var?
          </button>
          <LegalLinks align="left" />
        </div>
      </div>
      <SupportDialog open={helpOpen} onClose={() => setHelpOpen(false)} />
    </footer>
  );
};

export default LandingFooter;
